// extracted by mini-css-extract-plugin
module.exports = {"receiptPDF":"ViewPDF_receiptPDF__1m4Li","receiptPDFBlocker":"ViewPDF_receiptPDFBlocker__2Xlz4"};